import { memo, useRef, useEffect, useState } from 'react';

import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Flex, InputGroup, Input, Box } from '@chakra-ui/react';

import DsrManageOrgLogosModule from '../dsr-draft/DsrManageOrgLogosModule';
import '../../layout/components/header/styles/header.scss';
import SaveDraftProspectDsrButton from './draft-prospect-dsr/SaveDraftProspectDsrButton';
import DsrNavigationDrawerMenu from '../../layout/components/sidebar/components/DsrNavigationDrawerMenu';
import CreateProspectDsrQueryDrawer from './create-pdsr-query/CreateProspectDsrQueryDrawer';
import ShareProspectDsrButton from './ShareProspectDsrButton';
import DsrPageSideMenuDrawer from "../components/DsrPageSideMenuDrawer";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckTag from '../../global/components/helper-components/components/LaunchdeckTag';
import { DsrPreviewToggleButton } from "../dsr-draft/page-designer/toggle-button/DsrPreviewToggleButton";
import { setIsShrunkHeader } from '../../global/actions/global-actions';
import { truncateMobileDsrTitle } from '../../global/helpers/global-helpers';
import ProspectorHeaderOptionsButton from '../components/ProspectorHeaderOptionsButton';
import { setIsReadingMode } from '../actions/dsr-actions';
import { formatDisplayLocalDateTime } from '../helpers/timestamp-display-helper';

function DsrProspectHeader({
	pDsrId,
	dsrTitle,
	pdsrPagesLocalState,
	updatePdsr,
	handlePublishDsr,
	dsrStatus,
	dsrMainContact,
	handleChangeUserActionRequired,
	isLiveEdit,
	// Redux action
	setIsShrunkHeader,
	setIsReadingMode,
	// Redux
	dsrPropertiesRedux,
	prospectorLastSaved,
	isReadingMode,
	isMobileView,
	isPagePreviewMode,
	setIsPagePreviewMode,
	restrictPublishAsset,
	isProspectorOwner
}) {
	const { logoDisplayOption } = dsrPropertiesRedux || {}

	const headerTitleInputRef = useRef(null);

	const [currentDsrTitle, setCurrentDsrTitle] = useState("")
	const [showEditTitleInput, setShowEditTitleInput] = useState(false)
	const [isShrunk, setIsShrunk] = useState(false);
	const [displayedLastSaved, setDisplayedLastSaved] = useState(null);
	const [updateCount, setUpdateCount] = useState(0)

	const [largeLogoDisplay, setLargeLogoDisplay] = useState(false)
	const [showShareElements, setShowShareElements] = useState(false)
	const [showQueryDrawer, setShowQueryDrawer] = useState(false)

	const isDraft = ((dsrStatus === "draft") || (dsrStatus === "reverted-draft")) ? true : false
	const ctaCopyText = isDraft ? `Edit Prospector` : "";

	useEffect(() => {
		if (prospectorLastSaved) {
			setDisplayedLastSaved(prospectorLastSaved);
			setUpdateCount(prevCount => (prevCount + 1))
		}

	}, [prospectorLastSaved]);

	useEffect(() => {
		if (logoDisplayOption === "large-logos" || logoDisplayOption === "nametag") {
			setLargeLogoDisplay(true)
		} else if (logoDisplayOption === "default") {
			setLargeLogoDisplay(false)
		}
	}, [logoDisplayOption]);

	// Conditional styles for the banner
	const bannerStyles = {
		height: isShrunk ? '4em' : 'auto', // Shrinks height
		fontSize: isShrunk ? '0.875em' : '1.25em', // Shrinks font
		logoSize: isShrunk ? '2em' : '', // Shrinks logo
		transition: 'all 0.3s ease-in-out', // Smooth transition
		flexDirection: isShrunk ? 'row' : 'column',
		display: isShrunk ? 'flex' : 'block',
		alignItems: isShrunk ? 'left' : 'center',
	};

	const handleBannerClick = () => {
		setIsShrunk(!isShrunk)
		setIsShrunkHeader(!isShrunk)
	};

	const displayedTitle = dsrTitle ? truncateMobileDsrTitle(dsrTitle) : "";

	// UX listeners
	useEffect(() => {
		document.addEventListener("keydown", handleHitKey, true);
		document.addEventListener("click", handleClickEditInput, true);
		return () => {
			document.removeEventListener("keydown", handleHitKey, true);
			document.removeEventListener("click", handleClickEditInput, true);
		};
	});

	const handleInputChange = (event) => {
		if (event.target.name === "title") {
			setCurrentDsrTitle(event.target.value)
		}
	}

	const handleHitKey = (event) => {
		if (event.key === "Escape") {
			setShowEditTitleInput(false)
		} else if (event.key === 'Enter') {
			if (event.target.name === "title") {
				clickOutsideAutosave()
			}
		}
	};

	const clickOutsideAutosave = () => {
		setShowEditTitleInput(false)

		if (currentDsrTitle.trim().length > 0) {
			updatePdsr({
				pDsrId,
				dsrTitle: currentDsrTitle,
				sourceEvent: "update-pdsr-title"
			})
		} else (
			setCurrentDsrTitle(dsrTitle ? dsrTitle : "-")
		)
	}

	const handleClickEditInput = (event) => {
		if (headerTitleInputRef.current && !headerTitleInputRef.current.contains(event.target)) {
			clickOutsideAutosave()
		}
	};

	const renderDsrTitle = () => {

		if (showEditTitleInput) {
			return (
				<Flex fontWeight='600' lineHeight='1.875em' ref={headerTitleInputRef} >
					<InputGroup
						size="2em"
						width="100%"
						maxWidth='35%'
						minWidth='25em'
						border='none'
					>
						<Input
							name="title"
							value={currentDsrTitle}
							onChange={handleInputChange}
							onKeyDown={handleHitKey}
							autoFocus={true}
							// onFocus={e => e.currentTarget.select()}
							fontSize='1.25em'
							border='1px solid'
							borderColor='#3295EC'
							borderRadius='0.25em'
							paddingLeft='5px'
							lineHeight='1.875em'
							fontWeight="600"
						/>

					</InputGroup></Flex>
			)

		} else {
			return (
				<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' justify={['center', 'center', 'flex-start', 'flex-start']} pb={['1em', '1em', '0', '0']}>
					<Flex
						cursor={isDraft && 'pointer'}
						onClick={() => isDraft && setShowEditTitleInput(!showEditTitleInput)}
						border='1px solid'
						borderColor='transparent'
						paddingLeft='5px'
					>
						{dsrTitle}
					</Flex>
				</Flex>
			)
		}
	}

	if (isDraft === true || !!isLiveEdit) {
		return (
			<>
				<Flex className='dsr-header__section'>
					<Flex className='dsr-header__container' align='center'>
						<Flex justify='flex-start' align='center' pb='0.25em'>
							<DsrNavigationDrawerMenu darkMode={true} />
							<Box
								className="page-title"
								fontSize='1.25em' fontWeight='600' lineHeight='1.85em' color='white'
								display='inline-block' ml='2em'>
								{ctaCopyText}
							</Box>
							<Box ml='0.5em'>
								<LaunchdeckTag bg='gray.600' color='white' label='Draft' />
							</Box>
						</Flex>

						<Flex position='absolute' key={updateCount} visibility={updateCount <= 0 && 'hidden'} className='fade-in' fontSize='0.65em' color='white' fontWeight='500' top='5em' left='9em'>
							Autosaved:   {formatDisplayLocalDateTime(displayedLastSaved)}
						</Flex>

						<Flex>
							<DsrPreviewToggleButton
								offLabelText="Edit"
								onLabelText="Preview"
								isChecked={isPagePreviewMode}
								setIsChecked={setIsPagePreviewMode}
							/>
						</Flex>

						<Flex>
							<Flex gap={6} pr='1em'>
								<Box>
									<SaveDraftProspectDsrButton
										pDsrId={pDsrId}
										dsrPages={pdsrPagesLocalState}
									/>
								</Box>
								<Box>
									<LaunchdeckButton bg='brandGreen.500' color='white'
										onClick={() => {
											if (restrictPublishAsset) {
												handleChangeUserActionRequired('subscription-nudge', {
													titleText: `⚡ You reached the published Prospector free limit`,
													copyText: "Upgrade to publish unlimited Prospectors, get detailed sales intelligence & collaborate with co-workers easily"
												})
											} else {
												handlePublishDsr()
											}
										}

										}
										label='Publish' />
								</Box>
							</Flex>
						</Flex>

					</Flex>
				</Flex>

				<Flex className='dsr-content__dsr-top-banner'>
					<Flex align='center' gap='1em' py={logoDisplayOption === "nametag" && '1em'} minH='4.5em'  >
						<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption === "nametag" ? 'nametag' : 'prospect-dsr'} isPagePreviewMode={isPagePreviewMode} logoSize={largeLogoDisplay && '3.5em'} />
						{renderDsrTitle()}
					</Flex>

				</Flex>
			</>
		);
	} else if (isDraft === false) {
		if (!!isMobileView) {
			return (
				<>
					<Flex className='dsr-header__section' align='center'>
						<Flex className='dsr-header__container'>
							<Flex justify='flex-start' align='center'>
								<DsrPageSideMenuDrawer isProspectPage={true} />
								{(!!isProspectorOwner) &&
									<Box
										className="page-title"
										fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
										display='inline-block' ml={isMobileView ? '1em' : '2em'}>
										Manage Prospector
									</Box>
								}

							</Flex>
						</Flex>


						<Flex gap='1em'>

							<ShareProspectDsrButton pDsrId={pDsrId} dsrStatus={dsrStatus} isMobileView={isMobileView} showShareElements={showShareElements} />

							<Box className="cta-lower-right-button-container" display={isProspectorOwner && "none"} data-driver="prospector-tour-step-3A">
								<CreateProspectDsrQueryDrawer pDsrId={pDsrId} dsrMainContact={dsrMainContact} />
							</Box>
						</Flex>


					</Flex>

					<Box className='dsr-content__dsr-top-banner'
						onClick={handleBannerClick} // Shrink on click
						height={bannerStyles.height}
						transition={bannerStyles.transition} // Smooth height transition
					>
						<Flex flexDirection='row' justify='space-between' align={isShrunk && "center"} width='100%' alignItems={isShrunk ? 'flex-start' : 'center'} p={!isShrunk && '0 1em'}>
							<Flex flexDirection={bannerStyles.flexDirection} alignItems={bannerStyles.alignItems} width='100%' alignContent={'center'} >
								<DsrManageOrgLogosModule logoDisplayMode={'prospect-dsr'} />
								<Flex w='100%' justify={isShrunk ? 'flex-start' : 'center'} alignContent={'center'}>
									<Box fontWeight='600'
										lineHeight='1.875em' justify='flex-start'
										textAlign={isShrunk ? 'left' : 'center'}
										alignContent='center'
										fontSize={bannerStyles.fontSize} // Dynamic font size
										className={isShrunk && 'truncate-long-text'}
										maxW={isShrunk ? '15em' : '100%'}
										whiteSpace={!isShrunk && 'pre-wrap'}
									>
										{displayedTitle}
									</Box>
								</Flex>
							</Flex>
						</Flex>

					</Box>
				</>
			)
		} else {
			return (
				<>
					{isProspectorOwner &&
						<Flex className='dsr-header__section' align='center'>
							<Flex className='dsr-header__container'>
								<Flex justify='flex-start' align='center'>
									<Box data-driver="prospector-tour-step-5">
										<DsrNavigationDrawerMenu darkMode={true} />
									</Box>
									<Box
										className="page-title"
										fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
										display='inline-block' ml={isMobileView ? '1em' : '2em'}>
										Manage Prospector
									</Box>
									<Box ml='0.5em'>
										<LaunchdeckTag bg='green.500' color='white' label='Active' />
									</Box>
								</Flex>

								<Flex align='center' gap={6}>
									<ProspectorHeaderOptionsButton
										setIsReadingMode={setIsReadingMode}
										isReadingMode={isReadingMode}
										pDsrId={pDsrId}
										isProspectorOwner={isProspectorOwner}
										dsrTitle={dsrTitle}
										handleChangeUserActionRequired={handleChangeUserActionRequired}
										setShowShareElements={setShowShareElements}
										setShowQueryDrawer={setShowQueryDrawer}
									/>

								</Flex>


							</Flex>
						</Flex>
					}

					<Flex className='dsr-content__dsr-top-banner'>
						<Box display={['flex', 'flex', 'flex', 'none', 'none']}>
							<DsrPageSideMenuDrawer isProspectPage={true} />
						</Box>
						<Flex data-driver="prospector-tour-step-1" align='center' gap='1em' py={logoDisplayOption === "nametag" && '1em'} minH='4.5em'>
							<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption === "nametag" ? 'nametag' : 'prospect-dsr'} isPagePreviewMode={isPagePreviewMode} logoSize={largeLogoDisplay && '3.5em'} />
							{renderDsrTitle()}
						</Flex>

						<Flex gap='1em'>
							<ShareProspectDsrButton pDsrId={pDsrId} dsrStatus={dsrStatus} isMobileView={isMobileView} showShareElements={showShareElements} />

							<Box data-driver="prospector-tour-step-3A">
								<CreateProspectDsrQueryDrawer pDsrId={pDsrId} dsrMainContact={dsrMainContact} showQueryDrawer={showQueryDrawer} />
							</Box>
						</Flex>


					</Flex>
				</>
			)
		}
	} else return null

};


const mapStateToProps = (state) => ({
	dsrPropertiesRedux: state.draftDsrProperties.properties,
	isMobileView: state.mobileViewMode.isMobileView,
	restrictPublishAsset: state.restrictPublishAsset.results,
	isReadingMode: state.isReadingMode.results,
	isProspectorOwner: state.prospectorOwner.isProspectorOwner,
	prospectorLastSaved: state.dsrLastSaved.results,
})


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setIsShrunkHeader,
			setIsReadingMode
		},
		dispatch,
	)

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrProspectHeader)))
